module.exports = __webpack_public_path__ + "static/media/info_blue.40f917ea.svg";